<template>
    <div class="image-gallery__container" v-show="selectedPaint">
        <img class="img-responsive starburst" src="/images/configurator/stellantis-starburst.svg"
                alt="Stellantis Starburst">

        <div class="image-gallery__delivery" v-if="showDelivery && deliveryTime !== false">
            <div class="image-gallery__delivery-header"></div>
            <div class="image-gallery__delivery-text">Available in {{ deliveryTime }} weeks</div>
        </div>

        <template v-if="isCarousel">
            <VueSlickCarousel v-bind="settings">
                <picture v-for="(url, i) in urls" :key="i">
                    <source :srcset="url + '&fileType=webp'" type="image/webp"/>
                    <img class="img-responsive configurator-image" :class="{ 'smaller-image': smallImage === true }"
                            :src="url + '&fileType=png'"
                            :alt="model.model_title"/>
                </picture>
            </VueSlickCarousel>
            <span class="disclaimer" :class="{ 'disclaimer--left': (showDelivery && deliveryTime !== false) }">*Image for illustration purposes</span>
        </template>

        <template v-else>
            <picture>
                <source :srcset="urls[0] + '&fileType=webp'" type="image/webp"/>
                <img class="img-responsive configurator-image" :class="{ 'smaller-image': smallImage === true }"
                        :src="urls[0] + '&fileType=png'"
                        :alt="model.model_title"/>
            </picture>
        </template>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VueSlickCarousel from "vue-slick-carousel"

export default {
    props: {
        smallImage: {
            type: Boolean,
            required: false,
            default: false
        },
        isCarousel: {
            type: Boolean,
            required: false,
            default: true
        },
        showDelivery: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        VueSlickCarousel
    },
    data() {
        return {
            settings: {
                "lazyLoad": "ondemand",
                "arrows": true,
                "draggable": true,
                "edgeFriction": 0.35,
                "infinite": true,
                "speed": 500,
                "slidesToShow": 1,
                "slidesToScroll": 1
            }
        }
    },
    computed: {
        ...mapState(['model', 'capId', 'paintOptions', 'paintChoice', 'selectedNewVehicle', 'trimYear']),
        deliveryTime() {
            if (!this.selectedNewVehicle) {
                return false;
            }

            if (this.selectedNewVehicle.delivery_time == 0 || this.selectedNewVehicle.delivery_time == null) {
                return false;
            }

            return this.selectedNewVehicle.delivery_time;
        },
        selectedPaint() {
            const paintOptionsLength = this.paintOptions.length;
            if (paintOptionsLength === 0) {
                return false;
            }

            if (this.paintChoice == null) {
                return this.paintOptions[0];
            }

            for (let index = 0; index < paintOptionsLength; index++) {
                const paintOption = this.paintOptions[index];
                if (paintOption.id === this.paintChoice) {
                    return paintOption;
                }
            }

            return this.paintOptions[0];
        },
        paintId() {
            if (this.selectedPaint) {
                return this.selectedPaint.imagin_paint_id;
            }
            return false;
        },
        modelYear(){
            if(this.trimYear){
                return this.trimYear
            }else if(this.model.model_year){
                return this.model.model_year;
            }
            return false;
        },
        urlIdentifier() {
            this.year = this.modelYear;
            if (!this.selectedPaint) {
                return false;
            }

            if (this.model.model_year == null || this.model.model_year <= 0) {
                return this.selectedPaint.url_identifier;
            }

            if (this.selectedPaint.url_identifier.indexOf('modelYear') == -1) {
                return this.selectedPaint.url_identifier + '&modelYear=' + this.modelYear;
            }

            return this.selectedPaint.url_identifier.replace(/modelYear=(\d+)/, 'modelYear=' + this.modelYear)
        },
        urls() {
            return [
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=01`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=05`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=09`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=13`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=17`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=21`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=22`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=23`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=28`,
                `https://cdn.imagin.studio/getImage?customer=robinsandday&${this.urlIdentifier}&zoomType=fullscreen&steering=right&width=800&angle=29`,
            ];
        },
    },
}
</script>

<style lang="scss" scoped>
.image-gallery {
    &__container {
        width: 100%;
        position: relative;

        @media (max-width: 767px) {
            display: flex;
            flex-direction: column;
        }
    }

    &__delivery {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        @media (max-width: 767px) {
            order: 3;
        }
        @media (min-width: 768px) {
            position: absolute;
            right: 0;
            bottom: 0;
            max-width: 120px;
            align-items: stretch;
            justify-content: flex-start;
        }
    }

    &__delivery-header {
        background: linear-gradient(0deg, #0093D6 18.5%, #193B77 85.71%);
        border-radius: 8px 8px 0 0;
        height: 21px;
        width: 100%;
        user-select: none;

        @media (max-width: 767px) {
            display: none;
        }
    }

    &__delivery-text {
        text-align: center;
        background: #E5F4FA;
        color: #193B77;
        font-weight: 700;
        text-transform: uppercase;
        padding: 4px 10px 10px 10px;
        border-radius: 0 0 8px 8px;
        user-select: none;

        @media (max-width: 767px) {
            padding: 10px;
            width: 100%;
        }
    }
}

.logo {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -10;
    width: 20%;
}

.starburst {
    position: absolute;
    top: 0;
    right: 0;
    z-index: -10;
    width: 20%;
}

.smaller-image {
    max-height: 200px !important;
}

.disclaimer {
    font-size: 12px;
    opacity: 60%;

    @media (max-width: 767px) {
        text-align: center;
        order: 2;
        padding:  0 10px 10px 10px;
    }

    @media (min-width: 768px) {
        position: absolute;
        bottom: 0;
        right: 0;

        &--left {
            left: 0;
            right: initial;
        }
    }

}

</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/components/ImageGallery.vue